/**
 * Рендер HTML-страницы BookStack на web — нативно внутри портала, в фирменном
 * стиле (navy + low-round). Контент уже очищен на бэкенде (sanitize); в проде
 * добавить DOMPurify на клиенте как второй рубеж.
 */
const CSS = `
.kb-html { color: #1A2230; font-family: 'Source Sans 3', system-ui, sans-serif; font-size: 15px; line-height: 1.65; }
.kb-html h1,.kb-html h2,.kb-html h3,.kb-html h4 { font-family: 'Lexend', system-ui, sans-serif; color: #17356E; line-height: 1.25; margin: 1.4em 0 .5em; }
.kb-html h1 { font-size: 24px } .kb-html h2 { font-size: 20px } .kb-html h3 { font-size: 17px }
.kb-html p { margin: .6em 0 } .kb-html ul,.kb-html ol { padding-left: 1.4em; margin: .6em 0 }
.kb-html a { color: #1D4289; text-decoration: underline }
.kb-html img { max-width: 100%; height: auto; border-radius: 5px }
.kb-html pre { background: #EBEEF4; padding: 12px 14px; border-radius: 5px; overflow: auto; font-size: 13px }
.kb-html code { background: #EBEEF4; padding: 1px 5px; border-radius: 3px; font-size: 13px }
.kb-html pre code { background: none; padding: 0 }
.kb-html blockquote { border-left: 3px solid #B0863C; margin: .8em 0; padding: .2em 0 .2em 14px; color: #64748B }
.kb-html table { border-collapse: collapse; width: 100%; margin: 1em 0; font-size: 14px }
.kb-html th,.kb-html td { border: 1px solid #E2E8F0; padding: 7px 10px; text-align: left }
.kb-html th { background: #F4F6FA }
.kb-html hr { border: 0; border-top: 1px solid #E2E8F0; margin: 1.4em 0 }
`

export function KbHtml({ html }: { html: string }) {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="kb-html" dangerouslySetInnerHTML={{ __html: html }} />
    </>
  )
}
